<template>
  <div
    :id="id"
    :style="{ width: '95%', height: '100%', margin: '0 auto' }"
  ></div>
</template>

<script>
export default {
  props: ["id", "chartsData"],
  data() {
    return {};
  },
  watch: {
    chartsData: {
      handler(newvalue, oldvalue) {
        this.$nextTick(() => {
          this.drawLine();
        });
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    drawLine() {
      if (document.getElementById(this.id) == null) {
        return;
      }
      this.$echarts.dispose(document.getElementById(this.id));
      let myChart = this.$echarts.init(document.getElementById(this.id));
      myChart.setOption({}, true);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            return (
              params[0].name +
              "<br>" +
              params[0].marker +
              params[0].seriesName +
              " : " +
              params[0].value +
              "min"
            );
          },
        },
        legend: {
          show: false,
          top: "1%",
          right: "2%",
          textStyle: {
            color: "#333",
            fontSize: 12,
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "4%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            color: "#CBCBCB",
            fontSize: 12,
          },
          data: this.chartsData.xData,
        },
        yAxis: {
          type: "value",
          name: "单位(min)",
          nameTextStyle: {
            color: "#666",
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#EBEBEB",
            },
          },
          axisLabel: {
            show: true,
            color: "#999",
            fontSize: 12,
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: this.chartsData.xData.length >= 15 ? true : false,
            startValue: 0, //数据窗口范围的起始数值
            endValue: 14,
            xAxisIndex: [0],
            handleSize: 30,
            height: 10, //组件高度
            bottom: 5, //右边的距离
          },
        ],
        series: [
          {
            name: "运行时长",
            barMaxWidth: "20px",
            itemStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(123, 200, 255, 1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(53, 157, 245, 1)",
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
              borderRadius: [30, 30, 0, 0], //圆角大小
            },
            data: this.chartsData.data,
            type: "bar",
          },
        ],
      };
      myChart.setOption(option);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
